import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Lock, ArrowRight, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/AuthPage.css';

const AuthPage = ({ setUser, showToast }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post('http://localhost:5000/api/login', {
    email: email,       // Must match the names in your server.js destructuring
    password: password
});
      
      if (res.data.success) {
        // Save to local storage for session persistence
        localStorage.setItem('user', JSON.stringify(res.data.user));
        setUser(res.data.user);
        
        showToast(`Welcome back, ${res.data.user.name}!`, "success");
        navigate('/dashboard');
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Login Failed: Check your credentials";
      showToast(errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <motion.div 
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        className="auth-card"
      >
        <div className="auth-header">
          <div className="auth-logo-circle">
            <Shield size={32} color="#6366f1" />
          </div>
          <h2>Staff Login</h2>
          <p>Enter your administrator-provided credentials</p>
        </div>

        <form onSubmit={handleLogin} className="modern-form">
          <div className="input-group">
            <Mail size={18} className="input-icon" />
            <input 
              type="email" 
              placeholder="Email Address" 
              required 
              value={email} 
              onChange={e => setEmail(e.target.value)} 
            />
          </div>

          <div className="input-group">
            <Lock size={18} className="input-icon" />
            <input 
              type="password" 
              placeholder="Password" 
              required 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
            />
          </div>

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? 'Authenticating...' : 'Sign In'} 
            {!loading && <ArrowRight size={18} />}
          </button>
        </form>

        <div className="auth-footer">
          <p>Forgot password? Contact your IT Administrator</p>
        </div>
      </motion.div>
    </div>
  );
};

export default AuthPage;